import { ApplicationConfig, mergeApplicationConfig } from '@angular/core';
import { appCommonConfig } from './app.config.common';
import { multiBrandBrowserConfig } from '@lentau/bootstrap/application/app-common/app.config.browser';
import { SW_VERSION } from '@lentau/core/push/application/sw-version.generated';
import { provideServiceWorker } from '@angular/service-worker';

const browserConfig: ApplicationConfig = {
  providers: [
    provideServiceWorker(`ngsw-bootstrap.js?v=${SW_VERSION}`, {
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
};

export const appBrowserConfig: ApplicationConfig = mergeApplicationConfig(
  appCommonConfig,
  multiBrandBrowserConfig,
  browserConfig
);
